import { render } from "./ClaimSubmissions.vue?vue&type=template&id=b2b47802&ts=true"
import script from "./ClaimSubmissions.vue?vue&type=script&lang=ts"
export * from "./ClaimSubmissions.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__